import { ProgressBarState } from "../../../../ProgressBarView/types";

export function getBreakpointPosition(index: number, count: number) {
  if (index < 0) return 0;
  if (index > count - 1) return 1;

  if (count <= 2) {
    return (index + 1) / count;
  } else {
    return (index + 1) * (1.1 / (count + 1)) - 0.05;
  }
}

export function getProgressPercentage(state: ProgressBarState) {
  const progress = state.progress;
  const count = state.breakpoints.length;
  if (count <= 2) {
    return Math.min(progress, 100);
  } else if (progress >= 100) {
    return 100;
  } else {
    const step = 100 / count;
    const ratio = progress / step;
    const index = Math.floor(ratio);
    const decimals = ratio - index;
    const left = getBreakpointPosition(index - 1, count);
    const right = getBreakpointPosition(index, count);
    return 100 * (left + decimals * (right - left));
  }
}
